import * as types from '../../routes/types';

const initialState = null;

const handleShow = (state, action) => {
  const { id } = action.payload;

  return id.toString();
};

const currentId = (state = initialState, action) => {
  const { type } = action;

  if (type.indexOf('route/') === -1) {
    return state;
  }

  switch (type) {
    case types.ROUTE_EVENTS_SHOW:
      return handleShow(state, action);
    default:
      return () => null;
  }
};

export default currentId;

export const getEventsCurrentId = state => state.events.currentId;



// WEBPACK FOOTER //
// ./src/reducers/events/currentId.js